import { render, staticRenderFns } from "./Zhuce2.vue?vue&type=template&id=edb77838&scoped=true"
import script from "./Zhuce2.vue?vue&type=script&lang=js"
export * from "./Zhuce2.vue?vue&type=script&lang=js"
import style0 from "./Zhuce2.vue?vue&type=style&index=0&id=edb77838&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb77838",
  null
  
)

export default component.exports